import { cva } from 'class-variance-authority';
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { createAvatar } from '@dicebear/core';
import { thumbs } from '@dicebear/collection';
import { format } from 'date-fns';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function getDayTimePeriod() {
  const hour = new Date().getHours();
  if (hour >= 6 && hour < 12) return 'morning';
  if (hour >= 12 && hour < 18) return 'afternoon';
  return 'evening';
}

export const indexColorMap = {
  index: {
    0: 'bg-primary-light',
    1: 'bg-primary-blue-mid',
    2: 'bg-primary-yellow-light',
    3: 'bg-secondary-mid',
    4: 'bg-primary-sea-green-mid',
    5: 'bg-primary-blue-light',
    6: 'bg-primary-yellow-mid',
    7: 'bg-secondary-light',
    8: 'bg-primary-olive-green-light',
    9: 'bg-primary',
    10: 'bg-secondary-notice',
    11: 'bg-secondary',
  },
};

export const coloredTileVariants = cva('text-4xl leading-10 text-foreground opacity-80', {
  variants: indexColorMap,
});

export type ColoredTileIndex = keyof typeof indexColorMap.index;

export function getBenefitAvatar(seed: string) {
  return createAvatar(thumbs, {
    seed,
    size: 100,
  }).toDataUri();
}

export const formatCategory = (input: string): string => {
  return input
    .split('_')
    .map((word, index) =>
      index === 0 ? word.charAt(0).toUpperCase() + word.slice(1) : word.toLowerCase(),
    )
    .join(' ');
};

export const toFixedTwo = (value: string) => {
  try {
    const num = parseFloat(value);
    return String(value).includes('.') ? num.toFixed(2) : num;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (error) {
    return value;
  }
};

export const toMMDDYYYY = (date?: string | null) => {
  if (!date) return '';
  return format(new Date(date), 'MM/dd/yyyy');
};
